import { Dispatch, createContext } from "react";
import { State, Action, MetricsType, MetricsByType } from "./types";
import { Sorting, TimeFrame } from "../types";
import { reducer } from "./reducer";
import {
  createStateHook,
  createDispatchHook,
  createContextHook,
  createProvider,
} from "../../factory";
import { getTimeFrameRange } from "../../../components/Reports/utils";
import { getPersisted } from "../../../utils/storage";
import {
  WORKFLOW_PERSIST_KEY,
  // METRICS_TYPE_PERSIST_PROP
} from "./constants";
import { TIMEFRAME_PERSIST_PROP } from "../constants";

// Retrieve default time frame range
const persistedTimeFrame = getPersisted(
  { prop: TIMEFRAME_PERSIST_PROP, key: WORKFLOW_PERSIST_KEY },
  TimeFrame.Last12Months
);
const { timeFrameOption, current } = getTimeFrameRange(persistedTimeFrame);

// ! Uncomment once we re-introduce MetricsType.opened
// Retrieve metric type
// const persistedMetricType = getPersisted({ prop: METRICS_TYPE_PERSIST_PROP, key: WORKFLOW_PERSIST_KEY }, MetricsType.Completed)

/**
 * The initial state of workflow scene
 * ? @TODO: Load locally persisted state after hard refresh if needed
 */
export const initialState: State = {
  summaryLoading: false,
  summaryLoaded: false,
  metricsLoading: false,
  metricsLoaded: false,
  shouldUpdateSummary: true,
  shouldUpdateMetrics: true,
  timeFrameOption,
  startDate: current.from,
  endDate: current.to,
  sortingDirection: Sorting.Desc,
  selectedSites: [],
  sites: new Map(),
  active: new Set(),
  summary: {
    [MetricsType.Completed]: 0,
    [MetricsType.Opened]: 0,
    [MetricsByType.BySite]: {},
    [MetricsByType.ByResponsible]: {},
  },
  byType: MetricsByType.BySite,
  metrics: {
    // currentMetricsType: persistedMetricType,
    currentMetricsType: MetricsType.Completed,
    pinnedResponsibleList: [],
    [MetricsType.Completed]: {
      total: 0,
      [MetricsByType.BySite]: {},
      [MetricsByType.ByResponsible]: {},
    },
    [MetricsType.Opened]: {
      total: 0,
      [MetricsByType.BySite]: {},
      [MetricsByType.ByResponsible]: {},
    },
  },
};

const stateContext = createContext<State | undefined>(undefined);
const dispatchContext = createContext<Dispatch<Action> | undefined>(undefined);

export const WorkflowProvider = createProvider(
  stateContext,
  dispatchContext,
  reducer,
  initialState
);
export const useState = createStateHook(stateContext);
export const useDispatch = createDispatchHook(dispatchContext);
export const useWorkflow = createContextHook(stateContext, dispatchContext);
